// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"82214773","239":"21f5213f","455":"8c09d9a0"}[chunkId] + ".chunk.js";
};